import React, {useState, useEffect} from 'react'
import {getRouteAlerts} from '../services/routeService';
import handleApiError from '../helpers/handleApiError';
import { useHistory } from 'react-router-dom'
import {Container, Row, Col, Jumbotron } from 'react-bootstrap'


function RouteAlerts({setLoading}) {
    
    const history = useHistory();

    const [alerts, setAlerts] = useState({});

    const {opnotes} = alerts;


    useEffect(() => {
        (async () => {
            
            setLoading(true);
    
            try {
                const { data: foundAlerts } = await getRouteAlerts();
                
                // console.log(foundAlerts);

                setAlerts(foundAlerts);
                setLoading(false);
            }
            catch (ex) {
                setLoading(false);
                handleApiError(ex, history);
            }
        })(); 
    }, [history, setLoading]);
    
    
    return (
        <>
            <Container>
                <h2 className="text-center">Route Updates</h2>
                <Jumbotron>
                    <Row>
                        <Col>
                            <Container>
                                <dl>
                                    <dt>Latest Update</dt>
                                    <dd>{opnotes}</dd>    
                                </dl>
                            </Container>
                        </Col>
                    </Row>
                </Jumbotron>
            </Container>
        </>
    )
}
export default RouteAlerts